import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, Table, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import 'moment/locale/da';

const Headers = (props) => {
  return props.map((column) => (
    <th key={column.id}>{column.label}</th>
  ))
}

function ProductListModal({ productList, handleProductList }) {
  const [show, setShow] = useState(false);
  const [productListDate1, setProductListDate1] = useState();
  const [productListDate2, setProductListDate2] = useState();
  const columns = [{ id: 'name', label: 'VARETEKST' }, { id: 'count', label: 'ANTAL' }, { id: 'number', label: 'VARENR' }]

  const handleClose = () => {
    handleProductList(null)
    setShow(false)
  }
  const handleOnChangeDate1 = (value) => {
    const date1 = value.format("DD-MM-YYYY")
    setProductListDate1(date1)
  }
  const handleOnChangeDate2 = (value) => {
    const date2 = value.format("DD-MM-YYYY")
    setProductListDate2(date2)
  }
  const getProductList = () => {
    const date1 = moment(productListDate1,'DD-MM-YYYY').format('YYYY-MM-DD')
    const date2 = moment(productListDate2, 'DD-MM-YYYY').format('YYYY-MM-DD')
    handleProductList(date1, date2);
  }

  useEffect(() => {
    if (productList) {
      setShow(true)                 
      setProductListDate1(productList.date1)
      setProductListDate2(productList.date2)
    }
  }, [productList])
  if (!productList) {
    return <></>
  }
  const { data } = productList;
  return (
    <Modal
      show={show}
      onHide={() => handleClose()}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Varebehov
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>Periode:</Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <Datetime
              value={productListDate1}
              closeOnSelect={true}
              dateFormat={"DD-MM-YYYY"}
              timeFormat={false}
              onChange={handleOnChangeDate1}
            />
          </Col>
          <Col>
            <Datetime
              value={productListDate2}
              closeOnSelect={true}
              dateFormat={"DD-MM-YYYY"}
              timeFormat={false}
              onChange={handleOnChangeDate2}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <Button onClick={() => getProductList()}>Hent varebehov</Button>
          </Col>
        </Row>
        <Row>
          <Table responsive bordered striped hover>
            <thead>
              <tr>{Headers(columns)}</tr>
            </thead>
            <tbody>
              {data.map(
                (item, index) => {
                  return (
                    <tr key={index}>
                      {
                        columns.map((header) => {
                          const value = item[header.id]
                          return (<td key={header.id}>{value}</td>)
                        })
                      }
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
        </Row>
      </Modal.Body>
    </Modal >
  )
}
export { ProductListModal };
